import {combineReducers} from 'redux';

import {billingAddress} from './billingAddress/billingAddress';
import {billingAndShippingIsSame} from './billingAndShippingIsSame/billingAndShippingIsSame';
import {customerAddresses} from './customerAddresses/customerAddresses';
import {errorMessage} from './errorMessage/errorMessage';
import {isLoading} from './isSaveLoading/isSaveLoading';
import {shippingAddress} from './shippingAddress/shippingAddress';
import {shippingMethods} from './shippingMethods/shippingMethods';

export const deliveryStep = combineReducers({
    billingAddress,
    billingAndShippingIsSame,
    customerAddresses,
    errorMessage,
    isLoading,
    shippingAddress,
    shippingMethods,
});
